import * as React from "react";
import { ViewArticleModel } from "../models/Article";

type ArticleData = [ViewArticleModel[] | [], (Article: ViewArticleModel[] | []) => void];

const ArticleContext = React.createContext<ArticleData>([[], () => ({})]);

export default ArticleContext;